import useSWR from "swr";
import fetcher from "../../../hooks/fetcher.js";

/**
 * Fetches shop data for a given influencer route.
 *
 * @param {string | null} route - Influencer route segment (e.g. "johndoe").
 *   When null/empty the request is skipped (SWR conditional fetching).
 * @param {object} [options]
 * @param {string} [options.apiPath="/api/influencer/byRouteV2"]
 *   API endpoint prefix. The route is appended as a path segment.
 * @param {boolean} [options.preview=false]
 *   When true, appends `?preview=1` so the API returns hidden products
 *   (requires the requesting user to have access to the shop).
 */
export function useShop(
  route,
  { apiPath = "/api/influencer/byRouteV2", preview = false } = {},
) {
  const key = route
    ? `${apiPath}/${route}${preview ? "?preview=1" : ""}`
    : null;

  const { data, error, mutate } = useSWR(key, fetcher);

  return {
    data,
    isLoading: !data && !error,
    isError: !!error,
    error,
    mutate,
  };
}
